import React from "react";
import Experience from "./Experience";
import Skills from "./Skills";

const About = () => {
  return (
    <div className="aboutMe">
      <div className="d-md-flex d-lg-flex justify-content-between align-items-center">
        <div className="about__left">
          <h1 className="title text-center">About Me</h1>
          <p>
            Innovative Front End Developer with <b>8+ years experience</b>{" "}
            building and maintaining responsive websites in the recruiting
            industry.
          </p>
          <p>
            Apart from work, I love painting, photography, watching seasons or
            movies.
          </p>

          <div className="experience d-md-flex d-lg-flex justify-content-between text-left">
            <div className="experience__left">
              <h2>Experience</h2>
              <Experience
                role="Advanced Software Engineer (at Scientific Games)"
                period="Aug 2016 - present"
              />
              <Experience
                role="Sr. Software Engineer (at MINDTREE)"
                period="Aug 2015 - Aug 2016"
              />
              <Experience
                role="Web designer and developer (at Tech Active Agency)"
                period="Dec 2013 - Jul 2015"
              />
            </div>
            <div className="experience__left">
              <h2>Skills I have</h2>
              <Skills skills="html, CSS, JavaScript, jQuery, HTML5, Angular, React JS, Bootstrap, Scss, Photoshop, Bootsrtap, Web Components" />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default About;
